<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { onBrowserOrientationChange, isLandscapeOrientation } from "../utils/browser.js";

const props = defineProps({
  isCameraReady: Boolean,
  displayVideo: Function
});

const isVisible = ref(false);

function toggleOrientationModalVisibility(visibility) {
  isVisible.value = visibility;
  props.displayVideo(!visibility);
}

let orientationListener;

onMounted(() => {
  // Initially set the visibility of Orientation Modal (when the app starts in landscape)
  toggleOrientationModalVisibility(isLandscapeOrientation());
  // Continuously monitor the orientation
  orientationListener = onBrowserOrientationChange((isLandscape) => {
    toggleOrientationModalVisibility(isLandscape);
  });
});

onUnmounted(() => {
  if (orientationListener) {
    // Remove orientation listener
    orientationListener();
  }
});
</script>

<template>
<div v-if="isVisible" class="orientation-modal">
  <div class="orientation-content text_all">
    <div class="orientation-title">
      {{ $t("orientation.turn_device") }}
    </div>
    <div class="orientation-content-body">
      <div class="orientation-image">
        <img src="../assets/orientation.svg" width="100" height="100" />
      </div>
      <div class="orientation-message">
        {{ $t("orientation.vertically") }}
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.orientation-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
}
.orientation-content {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 320px;
  padding: 18px;
  background: #fff;
  transform: translate(-50%, -50%);
  border-radius: 6px;
}
.orientation-title {
  margin-bottom: 18px;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}
.orientation-content-body {
  display: flex;
}
.orientation-image {
  text-align: center;
}
.orientation-message {
  margin-top: 18px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
}
</style>
